const config = {
  apiBaseUrl: import.meta.env.REACT_APP_API_URL || 'https://api.stagehf.com',
  assetsUrl: import.meta.env.REACT_APP_ASSETS_URL || '',
  heapId: import.meta.env.REACT_APP_HEAP_ID || '',
  version: import.meta.env.REACT_APP_VERSION || '',
  hotjarId: import.meta.env.REACT_APP_HOTJAR_ID || '',
  hotjarSnippetVersion: import.meta.env.REACT_APP_HOTJAR_SNIPPET_VERSION || '',
  googleAnalyticsTrackingId: import.meta.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID || '',
  smartlookAnalyticsKey: import.meta.env.REACT_APP_SMARTLOOK_ANALYTICS_KEY || '',
  aes_secret_key: import.meta.env.REACT_APP_AES_SECRET_KEY || '',
  firebase_api_key: import.meta.env.REACT_APP_FIREBASE_API_KEY || '',
  firebase_auth_domain: import.meta.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  firebase_project_id: import.meta.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  firebase_storage_bucket: import.meta.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  firebase_messaging_sender_id: import.meta.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  firebase_app_id: import.meta.env.REACT_APP_FIREBASE_APP_ID || '',
  firebase_measurement_id: import.meta.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '',
  firebase_vapid_key: import.meta.env.REACT_APP_FIREBASE_VAPID_KEY || ''
}

export default config
